// Init Photoswipe.js
// es6
//
// uses:
// - https://github.com/dimsemenov/photoswipe
// - https://photoswipe.com/getting-started/

const options = {
    gallery: '[data-gallery]',
    children: '.photoswipe',
    pswpModule: () => import(window.ProjectEnv.photoswipe.module),
    showHideAnimationType: 'fade',
    bgOpacity: 1,
    arrowPrev: false,
    arrowNext: false,
    zoom: false,
    close: false,
    counter: false,
    paddingFn: (viewportSize) => {
        return {
            top: 20,
            bottom: 20,
            left: 20,
            right: viewportSize.x >= 1024 ? 208 + 44 + 20 : 20,
    };
  }
}

let lightbox;
let instance;

function getLightbox() {
    if (!lightbox) {
        lightbox = import(window.ProjectEnv.photoswipe.lightbox).then(
            (module) => module.default,
        );
    }
    return lightbox;
}

function initPhotoswipe() {
    if (
        typeof window.ProjectEnv === 'undefined' ||
        window.ProjectEnv === null ||
        !window.ProjectEnv.photoswipe
    ) {
        return;
    }

    if (
        window.ProjectEnv.photoswipe.module &&
        window.ProjectEnv.photoswipe.lightbox &&
        document.querySelector(options.gallery + ' ' + options.children)
    ) {
        getLightbox()
            .then((lightbox) => {
                if (instance) {
                    instance.destroy();
                }
                instance = new lightbox(options);

                return instance;
            })
            .then((instance) => {

                instance.on('uiRegister', () => {

                    instance.pswp.ui.registerElement({
                        name: 'custom-close',
                        order: 0,
                        appendTo: 'bar',
                        html: `
                            <button class="pswp__custom-button pswp__button--custom-close" aria-label="Close">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                </svg>
                            </button>
                        `,
                        onInit: (el, pswp) => {
                            el.querySelector('button').addEventListener('click', () => {
                                pswp.close();
                            });
                        }
                    });

                    instance.pswp.ui.registerElement({
                        name: 'custom-counter',
                        order: 10,
                        appendTo: 'bar',
                        html: '<div class="pswp__custom-counter"></div>',
                        onInit: (el, pswp) => {
                            const updateCounter = () => {
                                el.textContent = `${pswp.currIndex + 1} / ${pswp.getNumItems()}`;
                            };
                            pswp.on('change', updateCounter);
                            updateCounter();
                        }
                    });
                    
                    instance.pswp.ui.registerElement({
                        name: 'prev-button',
                        order: 20,
                        appendTo: 'bar',
                        html: `
                            <button
                                class="pswp__custom-button pswp__button--custom-prev"
                                type="button"
                                aria-label="Previous"
                                aria-controls="pswp__items"
                                title="Previous">
                                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                                </svg>
                            </button>
                        `,
                        onInit: (el, pswp) => {
                            el.querySelector('button').addEventListener('click', () => {
                                pswp.prev();
                            });
                        }
                    });
                
                    instance.pswp.ui.registerElement({
                        name: 'next-button',
                        order: 30,
                        appendTo: 'bar',
                        html: `
                            <button
                                class="pswp__custom-button pswp__button--custom-next"
                                type="button"
                                aria-label="Next"
                                aria-controls="pswp__items"
                                title="Next">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                                </svg>
                            </button>
                        `,
                        onInit: (el, pswp) => {
                            el.querySelector('button').addEventListener('click', () => {
                                pswp.next();
                            });
                        }
                    });

                    instance.pswp.ui.registerElement({
                        name: 'caption',
                        order: 40,
                        isButton: false,
                        appendTo: 'root',
                        html: 'Caption Text',
                    
                        onInit: (el, pswp) => {
                            const updateCaption = () => {
                                if(!pswp.currSlide) return;
                                const currSlideElement = pswp.currSlide.data.element;

                                let captionHTML = '';
                                if (currSlideElement) {
                                  const caption = currSlideElement.parentElement.querySelector("figcaption");
                                  if (caption) {
                                    captionHTML = caption.innerHTML;
                                  } else {
                                    captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
                                  }
                                }
                                el.innerHTML = captionHTML || '';
                            };
                            pswp.on('change', updateCaption);
                            updateCaption();
                        }
                    });
                

                });

                
  
                // Initialise PhotoSwipe instance
                instance.init();
            });
    }
}

initPhotoswipe();